import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import {Query} from 'react-apollo';
import {relatedStackups} from '../../../data/tool-stackups/queries';
import RelatedStackups from '../../../shared/library/cards/related-stackups';
import {Spinner} from './spinner';
import Circular, {LARGE} from '../../../shared/library/indicators/indeterminate/circular';
import {flattenEdges} from '../../../shared/utils/graphql';
import {PHONE} from '../../../shared/style/breakpoints';
import LoadMoreButton from '../../../shared/library/buttons/load-more';
import {updateQuery} from '../../../data/shared/updateToolQuery';

const Container = glamorous.div({
  padding: '50px 0 80px',
  width: '100%',
  [PHONE]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }
});

const Wrapper = glamorous.div({
  width: '100%',
  [PHONE]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }
});

export const Center = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  marginTop: 20
});

const Stackups = ({tool}) => {
  if (tool) {
    return (
      <Container>
        <Query query={relatedStackups} variables={{id: tool.id}}>
          {({loading, data, fetchMore}) => {
            const hasData = data && data.tool;
            if (loading && !hasData) {
              return (
                <Spinner>
                  <Circular size={LARGE} />
                </Spinner>
              );
            }

            if (hasData) {
              const relatedStackups = flattenEdges(data.tool.relatedStackups);
              const endCursor = data.tool.relatedStackups.pageInfo.endCursor;
              const hasNextPage = data.tool.relatedStackups.pageInfo.hasNextPage;
              return (
                <Wrapper>
                  <RelatedStackups
                    items={relatedStackups}
                    disableHeading={true}
                    disableCta={true}
                  />
                  {hasNextPage && (
                    <Center>
                      <LoadMoreButton
                        loading={loading}
                        onClick={() =>
                          fetchMore({
                            variables: {
                              after: endCursor
                            },
                            updateQuery
                          })
                        }
                      />
                    </Center>
                  )}
                </Wrapper>
              );
            }
          }}
        </Query>
      </Container>
    );
  }
  return null;
};

Stackups.propTypes = {
  tool: PropTypes.object
};

export default Stackups;
